const inactiveStores = [
];

export default (storeId) => !inactiveStores.includes(storeId);
